CustomTC.define('modules/options',['modules/util', 'modules/core'], function(util, core) {
    return {
        autoplay: 1,
        skincolor: 'f15d50',
        controlsColor: '183137',
        controlsDividerColor: '45595d',
        playerBackgroundColor: '0c181b',
        progressUpdateColor: 'rgba(137, 129, 129, 0.4)',
        subtitlesBackgroundColor: 'f15d50',
        subtitlesTextColor: '000000',
        currentVolume: 1,
        volume: 10,
        maxVolumeLevel: 10,
        fullscreen: 0,
        flashMovie: '',
        paused: 1,
        flashInterval: '',
        progressBarInterval: '',
        mode: 'html5',
        videoInfo: '',
        totalDuration: 0,
        currentKey: 0,
        totalPerf: 0,
        changing: 0,
        ended: 0,
        checkUserActive: 0,
        inactiveTimer: null,
        clickPlay: 1,
        triedPlay: 0,
        domain: '',
        changingTC: 0,
        jumpTime: 0,
        originalTime: {},
        changeOriginal: 0,
        firstTimeLoad: 0,
        tcVideoType: 'normal',
        video: '',
        user: null,
        getFlashPlayerBtn: '',
        iPhonePlay: false,
        hls: false,
        hlsLevelHeight: 720,
        hlsLevelWidth: 1280,
        hlsSquareSize: 1,
        hlsSquareNumber: 16,
        playing: false,
        audio: null,
        sound: null,
        soundVolume: null,
        pauseWidthVideo: null,
        prevTime: 0,
        defaultAvatar: '',
        vappType: '',
        vappMode: '',
        vappCloseTimer: null,
        showBackTC: 1,
        hlsSupport: false,
        live: false,
        thumbSound: '//tc-hls-test.s3.amazonaws.com/sounds/A-Tone-His_Self-1266414414.mp3',
        chatSound: '//tc-hls-test.s3.amazonaws.com/sounds/Blop-Mark_DiAngelo-79054334.mp3',
        showiPhoneOverlay: false,
        soundIsEmpty: true,
        cacheSkip: 0,
        visibilityChange: '',
        hidden: '',
        iPhonePlayTip: '',
        interactiveTip: true,
        mainPlayButton: true,
        disableTranscription: false,
        mainPlayButtonPosition: '',
        followRedirectConfirmation: 'Do you want to redirect to TouchCast.com so that you can login there and be able to Follow this channel?',
        unfollowRedirectConfirmation: 'Do you want to redirect to TouchCast.com so that you can login there and be able to UnFollow this channel?',
        bookmarkRedirectConfirmation: 'Do you want to redirect to TouchCast.com so that you can login there and be able to Bookmark this TouchCast?',
        unbookmarkRedirectConfirmation: 'Do you want to redirect to TouchCast.com so that you can login there and be able to Remove Bookmark this TouchCast?',
        enableChatsSound: true,
        enableThumbsSound: true,
        enableSearch: true,
        encodingMechanism: 'old',
        livestreamId: '',
        livestreamState: '',
        hlsOriginal: '',
        apiUrl: '',
        apiSession: '',
        hlsStats: '',
        defaultSubtitle: '',
        hlsVod:false,
        livestreamAssetUrl:'',
        hlsPlaylistType:'',
        //get autoplay
        getAutoPlay: function() {
            return this.autoplay;
        },
        //set autoplay
        setAutoPlay: function(autoplay) {
            this.autoplay = autoplay;
        },
        //get skin color
        getSkinColor: function() {
            return this.skincolor;
        },
        //set skin color
        setSkinColor: function(color) {
            this.skincolor = color;
        },
        //get controls color
        getControlsColor: function() {
            return this.controlsColor;
        },
        //set controls color
        setControlsColor: function(color) {
            this.controlsColor = color;
        },
        //get controls divider color
        getControlsDividerColor: function() {
            return this.controlsDividerColor;
        },
        //set controls divider color
        setControlsDividerColor: function(color) {
            this.controlsDividerColor = color;
        },
        //get player background color
        getPlayerBackgroundColor: function() {
            return this.playerBackgroundColor;
        },
        //set player background color
        setPlayerBackgroundColor: function(color) {
            this.playerBackgroundColor = color;
        },
        //get progress update color
        getProgressUpdateColor: function() {
            return this.progressUpdateColor;
        },
        //set progress update color
        setProgressUpdateColor: function(color) {
            this.progressUpdateColor = color;
        },
        //get progress update color
        getSubtitlesBackgroundColor: function() {
            return this.subtitlesBackgroundColor;
        },
        //set progress update color
        setSubtitlesBackgroundColor: function(color) {
            this.subtitlesBackgroundColor = color;
        },
        //get progress update color
        getSubtitlesTextColor: function() {
            return this.subtitlesTextColor;
        },
        //set progress update color
        setSubtitlesTextColor: function(color) {
            this.subtitlesTextColor = color;
        },
        //get current volume
        getCurrentVolume: function() {
            return this.currentVolume;
        },
        //set current volumne
        setCurrentVolume: function(volume) {
            this.currentVolume = volume;
        },
        //get volume
        getVolume: function() {
            return this.volume;
        },
        setVolume: function(volume) {
            this.volume = volume;
        },
        // get flash movie
        getFlashMovie: function() {
            return this.flashMovie;
        },
        // set flash movie
        setFlashMovie: function(object) {
            if (object === '') {
                this.flashMovie = util.getFlashMovieObject(core.getAttr(core.init(this.element), 'id'));
            } else {
                this.flashMovie = util.getFlashMovieObject(object);
            }
            return this.flashMovie;
        },
        //get paused
        getPaused: function() {
            return this.paused;
        },
        //set paused
        setPaused: function(paused) {
            this.paused = paused;
        },
        //get mode
        getMode: function() {
            return this.mode;
        },
        //set mode
        setMode: function(mode) {
            this.mode = mode;
        },
        //get maximum volume level
        getMaxVolumeLevel: function() {
            return this.maxVolumeLevel;
        },
        // is full screen
        isFullscreen: function() {
            return this.fullscreen;
        },
        //set full screen
        setFullscreen: function(value) {
            this.fullscreen = value;
        },
        //get video info
        getVideoInfo: function() {
            return this.videoInfo;
        },
        //set video info
        setVideoInfo: function(info) {
            this.videoInfo = info;
        },
        //get duration
        getVideoDuration: function() {
            return this.duration;
        },
        //set  duration
        setVideoDuration: function(duration) {
            this.duration = duration;
        },
        //get total duration
        getTotalDuration: function() {
            return this.totalDuration;
        },
        //set total duration
        setTotalDuration: function(duration) {
            this.totalDuration = duration;
        },
        //get current key
        getCurrentKey: function() {
            return this.currentKey;
        },
        //set current key
        setCurrentKey: function(key) {
            this.currentKey = key;
        },
        //get total performances
        getTotalPerf: function() {
            return this.totalPerf;
        },
        //set total performances
        setTotalPerf: function(count) {
            this.totalPerf = count;
        },
        //get is changing
        isChanging: function() {
            return this.changing;
        },
        //set changing
        setChanging: function(change) {
            this.changing = change;
        },
        //get is ended
        isEnded: function() {
            return this.ended;
        },
        //set ended
        setEnded: function(ended) {
            this.ended = ended;
        },
        //is user active
        isUserActive: function() {
            return this.checkUserActive;
        },
        //set user active or not
        setUserActive: function(active) {
            this.checkUserActive = active;
        },
        //get click play
        getClickPlay: function() {
            return this.clickPlay;
        },
        //set click play
        setClickPlay: function(val) {
            this.clickPlay = val;
        },
        //get tried play
        getTriedPlay: function() {
            return this.triedPlay;
        },
        //set tried play
        setTriedPlay: function(tried) {
            this.triedPlay = tried;
        },
        //get domain
        getDomain: function() {
            return this.domain;
        },
        //set domain
        setDomain: function(domain) {
            this.domain = domain;
        },
        //is changing TC
        isChangingTC: function() {
            return this.changingTC;
        },
        //set changing TC
        setChangingTC: function(change) {
            this.changingTC = change;
        },
        //get jump time
        getJumpTime: function() {
            return this.jumpTime;
        },
        //set jump time
        setJumpTime: function(time) {
            this.jumpTime = time;
        },
        //get show back to original header
        getShowBackToOriginal: function() {
            return this.showBackTC;
        },
        //set show back to original header
        setShowBackToOriginal: function(val) {
            this.showBackTC = val;
        },
        //get show iphone overlay
        getShowiPhoneOverlay: function() {
            return this.showiPhoneOverlay;
        },
        //set show iphone overlay
        setShowiPhoneOverlay: function(val) {
            this.showiPhoneOverlay = val;
        },
        //get original time
        getOriginalTime: function(level) {
            if (isNaN(level))
                return 0;
            return this.originalTime[level + 1];
        },
        //set original time
        setOriginalTime: function(level, time) {
            this.originalTime[level] = time;
        },
        //is original changed
        isOriginalChanged: function() {
            return this.changeOriginal;
        },
        //set original changed
        setOriginalChanged: function(change) {
            this.changeOriginal = change;
        },
        //get first time load
        getFirstTimeLoad: function() {
            return this.firstTimeLoad;
        },
        //set first time load
        setFirstTimeLoad: function(val) {
            this.firstTimeLoad = val;
        },
        //get video type
        getTcVideoType: function() {
            return this.tcVideoType;
        },
        //set video type
        setTcVideoType: function(type) {
            this.tcVideoType = type;
        },
        //get video
        getVideo: function() {
            return this.video;
        },
        //set video
        setVideo: function(video) {
            this.video = video;
        },
        //get thumb sound
        getThumbSound: function() {
            return this.thumbSound;
        },
        //set thumb sound
        setThumbSound: function(sound) {
            this.thumbSound = sound;
        },
        //get chat sound
        getChatSound: function() {
            return this.chatSound;
        },
        //set chat sound
        setChatSound: function(sound) {
            this.chatSound = sound;
        },
        //get flash player image
        getFlashPlayerImg: function() {
            return this.getFlashPlayerBtn;
        },
        //set flash player image
        setFlashPlayerImg: function(img) {
            this.getFlashPlayerBtn = img;
        },
        //get is iPhone play
        isiPhonePlay: function() {
            return this.iPhonePlay;
        },
        //set iphone play
        setiPhonePlay: function(val) {
            this.iPhonePlay = val;
        },
        //get is hls play
        isHls: function() {
            return this.hls;
        },
        //set hls play
        setHls: function(val) {
            this.hls = val;
        },
        //set hls vod
        setHlsVod: function(val) {
            this.hlsVod = val;
        },
        // get hls vod
        getHlsVod: function() {
            return this.hlsVod;
        },
        //set hls orginal
        setOriginalHls: function(val) {
            this.hlsOriginal = val;
        },
        // get hls original
        getOriginalHls: function() {
            return this.hlsOriginal;
        },
        //get is hls supported
        isHlsSupported: function() {
            return this.hlsSupport;
        },
        //set hls support
        setHlsSupport: function(val) {
            this.hlsSupport = val;
        },
        // get hls level height
        getHlsLevelHeight: function() {
            return this.hlsLevelHeight;
        },
        // get hls level width
        getHlsLevelWidth: function() {
            return this.hlsLevelWidth;
        },
        // set hls level height
        setHlsLevelHeight: function(val) {
            this.hlsLevelHeight = val;
        },
        // set hls level width
        setHlsLevelWidth: function(val) {
            this.hlsLevelWidth = val;
        },
        // set hls square size
        setHlsSquareSize: function(val) {
            this.hlsSquareSize = val;
        },
        // set hls square number
        setHlsSquareNumber: function(val) {
            this.hlsSquareNumber = val;
        },
        // get hls square size
        getHlsSquareSize: function() {
            return this.hlsSquareSize;
        },
        // get hls square number
        getHlsSquareNumber: function() {
            return this.hlsSquareNumber;
        },
        // set encoding mechanism
        setEncodingMechanism: function(val) {
            this.encodingMechanism = val;
        },
        // get encoding mechanism
        getEncodingMechanism: function() {
            return this.encodingMechanism;
        },
        // is hls live
        isLive: function() {
            return this.live;
        },
        // set is hls live
        setLive: function(val) {
            this.live = val;
        },
        //get is playing
        isPlaying: function() {
            return this.playing;
        },
        //set playing
        setPlaying: function(val) {
            this.playing = val;
        },
        //get audio
        getAudio: function() {
            return this.audio;
        },
        //set audio
        setAudio: function(audio) {
            this.audio = audio;
        },
        //get sound
        getSound: function() {
            return this.sound;
        },
        //set sound is empty
        setSoundIsEmpty: function(empty) {
            this.soundIsEmpty = empty;
        },
        //get sound is empty
        getSoundIsEmpty: function() {
            return this.soundIsEmpty;
        },
        //set sound
        setSound: function(sound) {
            this.sound = sound;
        },
        //get sound volume
        getSoundVolume: function() {
            return this.soundVolume;
        },
        //set sound volume
        setSoundVolume: function(soundVolume) {
            this.soundVolume = soundVolume;
        },
        //get pause width video
        getPauseWithVideo: function() {
            return this.pauseWidthVideo;
        },
        //set pause width video
        setPauseWithVideo: function(pauseWidthVideo) {
            this.pauseWidthVideo = pauseWidthVideo;
        },
        //get prev time
        getPrevTime: function() {
            return this.prevTime;
        },
        //set prev time
        setPrevTime: function(val) {
            this.prevTime = val;
        },
        //get default avatar image
        getDefaultAvatarImg: function() {
            return this.defaultAvatar;
        },
        //set default avatar image
        setDefaultAvatarImg: function(img) {
            this.defaultAvatar = img;
        },
        //get vapp type
        getVappType: function() {
            return this.vappType;
        },
        //set vapp type
        setVappType: function(type) {
            this.vappType = type;
        },
        //get vapp mode
        getVappMode: function() {
            return this.vappMode;
        },
        //set vapp mode
        setVappMode: function(mode) {
            this.vappMode = mode;
        },
        //get user
        getUser: function() {
            return this.user;
        },
        //get enable disable chat sound
        getEnableDisableChatSound: function() {
            return this.enableChatsSound;
        },
        //set enable disable chat sound
        setEnableDisableChatSound: function(enableChatsSound) {
            this.enableChatsSound = enableChatsSound;
        },
        //get enable disable thumbs sound
        getEnableDisableThumbsSound: function() {
            return this.enableThumbsSound;
        },
        //set enable disable thumbs sound
        setEnableDisableThumbsSound: function(enableThumbsSound) {
            this.enableThumbsSound = enableThumbsSound;
        },
        //get enable disable search
        getEnableSearch: function() {
            return this.enableSearch;
        },
        //set enable disable search
        setEnableDisableSearch: function(enableSearch) {
            this.enableSearch = enableSearch;
        },
        //set iphone play tip
        setiPhonePlayTip: function(iPhonePlayTip) {
            this.iPhonePlayTip = iPhonePlayTip;
        },
        //get iphone play tip
        getiPhonePlayTip: function() {
            return this.iPhonePlayTip;
        },
        //set default transcription state
        setDisableTranscription: function(disableTranscription) {
            this.disableTranscription = disableTranscription;
        },
        //get default transcription state
        getDisableTranscription: function() {
            return this.disableTranscription;
        },
        //set interactive tip state
        setInteractiveTip: function(interactiveTip) {
            this.interactiveTip = interactiveTip;
        },
        //get interactive tip state
        getInteractiveTip: function() {
            return this.interactiveTip;
        },
        //set main play button state
        setMainPlayButton: function(mainPlayButton) {
            this.mainPlayButton = mainPlayButton;
        },
        //get main play button state
        getMainPlayButton: function() {
            return this.mainPlayButton;
        },
        //set main play button position
        setMainPlayButtonPosition: function(mainPlayButtonPosition) {
            this.mainPlayButtonPosition = mainPlayButtonPosition;
        },
        //get main play button position
        getMainPlayButtonPosition: function() {
            return this.mainPlayButtonPosition;
        },
        //set livestream id
        setLivestreamId: function(livestreamId) {
            this.livestreamId = livestreamId;
        },
        //get livestream id
        getLivestreamId: function() {
            return this.livestreamId;
        },
        //set livestream state
        setLivestreamState: function(state) {
            this.livestreamState = state;
        },
        //get livestream state
        getLivestreamState: function() {
            return this.livestreamState;
        },
        //set default subtitle
        setDefaultSubtitle: function(state) {
            this.defaultSubtitle = state;
        },
        //get default subtitle
        getDefaultSubtitle: function() {
            return this.defaultSubtitle;
        },
        //set livestream asset url
        setLivestreamAssetUrl: function(livestreamAssetUrl) {
            this.livestreamAssetUrl = livestreamAssetUrl;
        },
        //get livestream asset url
        getLivestreamAssetUrl: function() {
            return this.livestreamAssetUrl;
        },
        //set userId
        setUser: function(user) {
            this.user = {
                getUserId: function() {
                    return user.userId;
                },
                getPostName: function() {
                    return user.postName;
                },
                getPerformanceUserId: function() {
                    return user.performaceUserId;
                },
                isSubscribed: function() {
                    return parseInt(user.isSubscribed) === 1 ? true : false;
                },
                isBookmarked: function() {
                    return parseInt(user.isBookmarked) === 1 ? true : false;
                },
                isRecasted: function() {
                    return parseInt(user.recasted) === 1 ? true : false;
                },
                getTotalComments: function() {
                    return (parseInt(user.totalComments) === 0 || isNaN(parseInt(user.totalComments))) ? 0 : user.totalComments;
                },
            };
        },
        //is logged in
        isLoggedIn: function() {
            return (this.getUser() && this.getUser().getUserId() !== '') ? true : false;
        },
        getFollowRedirectConfirmationMsg: function() {
            return this.followRedirectConfirmation;
        },
        setFollowRedirectConfirmationMsg: function(msg) {
            this.followRedirectConfirmation = msg;
        },
        getUnfollowRedirectConfirmationMsg: function() {
            return this.unfollowRedirectConfirmation;
        },
        setUnfollowRedirectConfirmationMsg: function(msg) {
            this.unfollowRedirectConfirmation = msg;
        },
        getBookmarkRedirectConfirmationMsg: function() {
            return this.bookmarkRedirectConfirmation;
        },
        setBookmarkRedirectConfirmationMsg: function(msg) {
            this.bookmarkRedirectConfirmation = msg;
        },
        getUnbookmarkRedirectConfirmationMsg: function() {
            return this.unbookmarkRedirectConfirmation;
        },
        setUnbookmarkRedirectConfirmationMsg: function(msg) {
            this.unbookmarkRedirectConfirmation = msg;
        },
        //set cache skip
        setCacheSkip: function(skip) {
            this.cacheSkip = skip;
        },
        //get cache skip
        getCacheSkip: function() {
            return this.cacheSkip;
        },
        //set api url
        setApiUrl: function(apiUrl) {
            this.apiUrl = apiUrl;
        },
        //get api url
        getApiUrl: function() {
            return this.apiUrl;
        },
        //set api session
        setApiSession: function(apiSession) {
            this.apiSession = apiSession;
        },
        //get api session
        getApiSession: function() {
            return this.apiSession;
        },
        // update hls stats
        updateHlsStats: function(stats) {
            this.hlsStats = stats;
        },
        // get hls stats
        getHlsStats: function() {
            return this.hlsStats;
        },
        //set hls playlist type
        setHlsPlaylistType: function(type) {
            this.hlsPlaylistType = type;
        },
        //get hls playlist type
        getHlsPlaylistType: function() {
            return this.hlsPlaylistType;
        }
    }
});
